import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { QuoteViewerService } from "src/app/core/services/quote-viewer.service";
import { QuoteLineItemRecord } from "src/app/shared/models/DTO/quote-viewer.dto";

@Component({
	selector: "app-quote-line-items",
	templateUrl: "./quote-line-items.component.html",
	styleUrls: ["./../quote-viewer.scss"],
})
export class QuoteLineItemsComponent implements OnInit {
	constructor(public app: AppService, public quoteService: QuoteViewerService) {}

	itemFamilies: string[] = [];
	itemsByFamily: {
		family: string;
		label: string;
		items: QuoteLineItemRecord[];
		total: number;
		sortOrder: number;
		descriptionHeader: string;
	}[] = [];

	selectedItemInfo: QuoteLineItemRecord;

	ngOnInit(): void {
		this.quoteService.quote.subscribe((data) => {
			if (data.QuoteLineItems?.records.length > 0) {
				this.getProductTypes(data.QuoteLineItems.records);
			}
		});
	}

	getProductTypes(lineItems: QuoteLineItemRecord[]) {
		this.itemFamilies = Array.from(new Set(lineItems.map((i) => i.Product2.Family)));
		lineItems.forEach((item) => {
			let itemType = this.itemsByFamily.find((i) => i.family === item.Product2.Family);
			if (itemType) {
				itemType.items.push(item);
				itemType.total += item.Extended_Price__c;
			} else {
				let sortOrder = 0;
				let label;
				let descriptionHeader;
				switch (item.Product2.Family) {
					case "Equipment":
						sortOrder = 1;
						label = "Equipment";
						descriptionHeader =
							"Equipment designed for your restaurant. Focus POS equipment is engineered to endure the beating that busy restaurants subject them to. Our equipment is also expertly matched to the Focus software so it's operation is seamless and efficient.";
						break;
					case "Recurring":
						sortOrder = 0;
						label = "Focus Suite";
						descriptionHeader =
							"State of the art, cloud-based Focus Restaurant Operations Suite is tried, true and robust. The Focus ROS Suite is designed from the ground-up to empower your restaurant to thrive.";
						break;
					case "Professional Services":
						sortOrder = 3;
						label = "Professional Services";
						break;
					default:
						sortOrder = 2;
						label = "Other";
						break;
				}
				this.itemsByFamily.push({
					family: item.Product2.Family,
					label: label,
					items: [item],
					sortOrder: sortOrder,
					descriptionHeader: descriptionHeader,
					total: item.Extended_Price__c,
				});
			}
		});

		this.itemsByFamily.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));
		this.itemsByFamily.forEach((item) => {
			item.items.sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
		});
	}
}
